<!-- <br>
<button mat-raised-button color="primary">Hola que tal</button> -->
<div class="container-fluid col center">
  <div style="margin-top: 10px">{{ name }}</div>
  <div id="logoportada" class="logo-portada"></div>
  <!--   <img src="assets/layout-img/logo-portada.png" alt="Ticketing" class="logo-portada" /> -->
</div>
